import rivets from 'rivets';
import BaseView from '../../core/baseView';
import ItalianTaxId from '../../layout/italianTaxId';

export default BaseView.extend({
  events: {
    'submit .js-register-form-private': 'onRegisterPrivateCustomerSubmit'
  },

  selectors: {
    taxId: '.js-tax-id input'
  },

  initialize: function() {
    this.$taxId = this.$el.find(this.selectors.taxId);

    if (this.$taxId) {
      this.taxId = new ItalianTaxId({
        el: this.$taxId
      });
    }

    this.setupRivetsBindings();
    this.bindEvents();

    var formModel = this.model;

    formModel
      .get('form')
      .trigger('change:accountType', formModel, formModel.get('accountType'));
  },

  bindEvents: function() {
    if (this.$taxId.length) {
      this.listenTo(
        this.model.get('form'),
        'change:showTaxId',
        this.onShowTaxId,
        this
      );
    }
  },

  setupRivetsBindings: function() {
    rivets.bind(this.$el, {
      viewModel: this.model
    });
  },

  onRegisterPrivateCustomerSubmit: function() {
    this.removeCompanyFromPrivateCustomer();
  },

  removeCompanyFromPrivateCustomer: function() {
    const formModel = this.model.get('form');
    const isPrivateCustomer = !formModel.get('showBusinessForm');

    if (isPrivateCustomer) {
      formModel.set('company', '');
    }
  },

  onShowTaxId: function(model, value) {
    if (this.$taxId) {
      this.$taxId.attr('data-validate', value);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/login/registerFormPrivateCustomerView.js
 **/